<template>
  <div class="home">
    <div class="head">
      <div class="head-title">基础设置</div><el-button style="height:4.0rem" type="primary"
        @click="goShop()">商城管理登录入口</el-button>
    </div>
    <div class="">
      <div class="">
        <div class="tianjia">
          <el-form ref="form" :model="form" label-width="13.0rem" style="margin-top: 2.0rem">
            <el-form-item label="关键词">
              <el-input clearable v-model.trim="form.tableData.keywords" style="width: 30%"></el-input>
            </el-form-item>
            <el-form-item label="网站名称">
              <el-input clearable v-model.trim="form.tableData.website" style="width: 30%"></el-input>
            </el-form-item>
            <el-form-item label="网站描述">
              <el-input clearable type="textarea" autosize="true" v-model.trim="form.tableData.description"
                style="width: 30%"></el-input>
            </el-form-item>
            <el-form-item label="用户使用时间/天">
              <el-input clearable type="number" v-model="form.tableData.past_time" style="width: 10%"></el-input>
              <!-- <span style="font-size: 2.0rem"
                >&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;天</span
              > -->
            </el-form-item>
            <el-form-item label="附件管理">
              <el-radio v-model="radio" label="1">本地上传</el-radio>
              <el-radio v-model="radio" label="2">腾讯云上传</el-radio>
              <el-radio v-model="radio" label="3">阿里云上传</el-radio>
            </el-form-item>
            <el-form-item label="购买/年">
              <el-input clearable v-model="form.tableData.buy" type="number" style="width: 10%"></el-input>
              <!-- <span style="font-size: 2.0rem"
                >&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;年以上</span
              > -->
            </el-form-item>
            <el-form-item label="赠送/年">
              <el-input clearable v-model="form.tableData.give" type="number" style="width: 10%"></el-input>
              <!-- <span style="font-size: 2.0rem"
                >&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;年</span
              > -->
            </el-form-item>
            <el-form-item label="对接商城配置域名">
              <el-input clearable v-model.trim="form.tableData.saas_domain" style="width: 30%"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit('form')">修改</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import * as url from "url";
export default {
  data() {
    return {
      form: {
        tableData: [],
      },
      msg: "2",
      radio: "1",
      username: "",
      title: {},
    };
  },
  mounted() {
    if (window.sessionStorage.getItem("title")) {
      let title = JSON.parse(window.sessionStorage.getItem("title"));
      this.title = title;
    }
    if (window.sessionStorage.getItem("userinfone")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfone"));
      this.username = userinfo;
    }
    this.about();
  },
  methods: {
    goShop() {
      window.open(`${this.form.tableData.saas_domain}/admin`)
    },
    // 提交过后输出的数据
    about() {
      this.axios
        .post(
          "/api/setup/getSetList",
          qs.stringify({
            totaltoken: this.username.totaltoken,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          var title = res.data.data;
          sessionStorage.setItem("title", JSON.stringify(title));
          var a = document.title;
          document.title = title[0].website + "-" + a;
          this.form.tableData = res.data.data[0];
          this.radio = res.data.data[0].photo_status.toString();
        })
        .catch(function (err) { });
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.tableData.photo_status = this.radio;
          this.axios
            .post(
              "/api/setup/editSet",
              qs.stringify({
                id: this.form.tableData.id,
                keywords: this.form.tableData.keywords,
                description: this.form.tableData.description,
                photo_status: this.form.tableData.photo_status,
                website: this.form.tableData.website,
                past_time: this.form.tableData.past_time,
                buy: this.form.tableData.buy,
                give: this.form.tableData.give,
                totaltoken: this.username.totaltoken,
                saas_domain: this.form.tableData.saas_domain,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              this.about();
              if (res.data.msg == "登录超时") {
                this.$router.push("/Tagent");
              }
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
            })
            .catch(function (err) { });
        } else {
          return false;
        }
      });
    },
  },
  // 1.用户分配
  //3.用户选择 附件管理

};
</script>
<style scoped>
.home {
  padding: 2rem;
  border-radius: .8rem;
  box-shadow: .3rem .3rem 2rem 0 rgba(0,0,0,0.1);
}

.body_html {
  width: 100%;
  height: 100%;
}

.wei_body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  box-shadow: .0rem 1px 6px .0rem rgba(0, 0, 0, 0.2);
  padding: 23px 31px;
  overflow: hidden;
  overflow-y: auto;
}

.tianjia {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}

.tianjia>main {
  font-size: 26px;
}

.bule {
  width: 100%;
  height: 69px;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}

.head {
  display: flex;
  justify-content: space-between;
}
</style>
